(function (angular) {
    angular.module("app").controller("DocumentationCtrl", ["$scope", "DocumentationService", "$showdown", "markdownDocument", function ($scope, DocumentationService, $showdown, markdownDocument) {
        converter = new showdown.Converter();
        converter.setOption('tables', true);
        converter.setOption('strikethrough', true);
        $scope.text = converter.makeHtml(markdownDocument);
    }]);
})(angular);